<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <path d="M1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 10.7916 13.3658 13.2026 11 14.3265V12.5C11 12.2239 10.7761 12 10.5 12C10.2239 12 10 12.2239 10 12.5V15.5C10 15.7761 10.2239 16 10.5 16H13.5C13.7761 16 14 15.7761 14 15.5C14 15.2239 13.7761 15 13.5 15H11.8758C14.3346 13.6357 16 11.0128 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 8.27614 0.223858 8.5 0.5 8.5C0.776142 8.5 1 8.27614 1 8ZM8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10ZM8 9C7.44772 9 7 8.55228 7 8C7 7.44772 7.44772 7 8 7C8.55228 7 9 7.44772 9 8C9 8.55228 8.55228 9 8 9Z" />
  </svg>
</template>
